/*
 * @Description: 字段备注参考 /personnel
 * @Date: 2020-05-27 16:45:20
 */

import Vue from 'vue';
import Router from 'vue-router';

import Layout from '@/page/layout/index.vue';
import s1 from '@/page/account/index.vue';
import s2 from '@/page/account/person.vue';
import s3 from '@/page/bill/index.vue';
import s11 from '@/page/e-contract/sunList.vue';
import {
  ProjectClassify as s15,
  surveyQuestionnaireEdit as s16,
  ConfigurableQuestionnaireEdit as s46
} from '@/page/project-classify/app.js';
import s18 from '@/page/project-record/index.vue';
import s19 from '@/page/project-record/views/task-check-log.vue';
import s20 from '@/page/project-record/views/task-record/task-quick-review-table.vue';
import s34 from '@/page/settle/index.vue';
import s35 from '@/page/riskManagement/index.vue';
import s37 from '@/page/download/list.vue';
import s41 from '@/page/login/index1.vue';
import s42 from '@/page/pCenter/index.vue';
import s44 from '@/page/BI/index.vue';
import s44_1 from '@/page/BI-old/index.vue';
import projectSettled from '@/page/settlementCenter/projectSettled';
import orderMgmt from '@/page/settlementCenter/orderMgmt';
import s48 from '@/page/zone/list.vue';
import s49 from '@/page/zone/detail.vue';

//--------------------- accountManagement -------------------//
import { s51, s52, s53 } from '@/page/accountManagement';

import s400 from '@/page/information/list.vue';
import s401 from '@/page/information/detail.vue';

import s420 from '@/page/project-personnel-manage/index.vue';
// import s421 from '@/page/project-personnel-inside/index.vue';
import s422 from '@/page/project-personnel-inside/list/index.vue';

import s97 from '@/page/dutypaidProof/list.vue';
import { checkTerminalPayMgr } from '../api/ajax';

Vue.use(Router);
const originalPush = Router.prototype.push;
// push方法,防止重复跳转相同route后报错
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const parentRoute = [
  //父级菜单，asideName对应侧边路由列表名称
  {
    path: '/login',
    name: 'login',
    component: s41,
    hidden: true
  },
  {
    path: '/assign/bi',
    name: 'bi',
    component: s44,
    meta: {
      name: 'BI报表',
      hasAside: true,
      asideName: 'projectAsideList'
    }
  },
  {
    path: '/assign/bi-old',
    name: 'bi-old',
    component: s44_1,
    meta: {
      name: 'BI报表',
      hasAside: true,
      asideName: 'projectAsideList'
    }
  },
  {
    path: '/pCenter',
    component: Layout,
    redirect: '/pCenter/index',
    name: 'pCenter',
    meta: {
      icon: 'http://cdn.yxvzb.com/WEB/sass/img/qianyuexinxi-weidianji.png',
      activeIcon: 'http://cdn.yxvzb.com/WEB/sass/img/qianyuexinxi.png',
      name: ' 个人中心'
    },
    children: [
      {
        path: 'index',
        name: 'pCenter',
        component: s42,
        meta: {
          name: '个人中心'
          // homeMenu: false
        }
      }
    ]
  },
  {
    path: '/home',
    redirect: '/v3/home/index'
  },
  {
    path: '/',
    component: Layout,
    redirect: '/v3/home/index',
    children: [
      {
        path: '/v3/home/index',
        name: 'home',
        meta: {
          name: '首页',
          vue3: true
        }
      }
    ]
  },
  {
    path: '/signAndContract',
    component: Layout,
    redirect: '/contractInformation/naturalPerson',
    name: 'signAndContract',
    meta: {
      name: '签约以及合同管理'
    }
  },
  {
    path: '/infoManage/index',
    component: Layout,
    name: 'infoManage',
    redirect: '/v3/info-manage/list',
    children: [
      {
        path: '/v3/info-manage/list',
        name: 'infoManageIndex',
        meta: {
          name: '自然人信息管理',
          vue3: true
        }
      }
    ]
  },
  // {
  //   path: '/infoManage',
  //   component: Layout,
  //   name: 'infoManage',
  //   meta: {
  //     name: '自然人信息管理'
  //   },
  //   children: [
  //     {
  //       path: '/infoManage/index',
  //       name: 'infoManageIndex',
  //       component: s45,
  //       meta: {
  //         name: '自然人信息管理'
  //       }
  //     }
  //   ]
  // },
  {
    path: '/accountManagement',
    component: Layout,
    redirect: '/accountManagement/index',
    // name: 'accountManagement',
    meta: {
      name: '账号管理'
    },
    children: [
      {
        path: 'index',
        name: 'accountManagement',
        component: s51,
        meta: {
          name: '账号管理',
          hasAside: true,
          // asideName: 'orderAsideList',
          asideName: 'accountManagementAsideList'
        }
      }
    ]
  },
  {
    path: '/account',
    component: Layout,
    redirect: '/account/index',
    meta: {
      icon: 'http://cdn.yxvzb.com/WEB/sass/img/qianyuexinxi-weidianji.png',
      activeIcon: 'http://cdn.yxvzb.com/WEB/sass/img/qianyuexinxi.png',
      name: '结算中心'
    },
    children: [
      {
        path: 'index',
        name: 'account',
        component: s1,
        meta: {
          name: '结算中心',
          hasAside: true,
          // asideName: 'orderAsideList',
          asideName: 'settlementCenterList'
        },
        children: [
          // 概要
          {
            path: 'dashboard',
            name: 'account|dashboard',
            component: () =>
              import('@/page/account/components/dashboard/dashboard.vue')
          },
          // 结算管理
          {
            path: 'mgmt',
            name: 'account|mgmt'
          }
        ]
        // redirect: '/account/index/dashboard'
      },
      {
        path: 'person',
        name: 'person',
        component: s2,
        meta: {
          name: '企业信息'
        }
      },
      {
        path: 'order',
        name: 'order',
        component: Layout,
        redirect: '/orderMgmt',
        meta: {
          name: '我的订单',
          asideName: 'orderAsideList',
          hasAside: true,
          redirect: '/orderMgmt/list'
        }
      }
    ]
  },

  {
    path: '/download',
    component: Layout,
    redirect: '/download/list',
    name: 'download',
    meta: {
      name: '下载中心'
    },
    children: [
      {
        path: 'list',
        name: 'downloadList',
        component: s37,
        meta: {
          name: '下载中心'
        }
      }
    ]
  },
  {
    path: '/projectPersonnelManage',
    component: Layout,
    redirect: '/projectPersonnelManage/list',
    name: 'projectPersonnelManage',
    meta: {
      name: '项目人员管理'
    },
    children: [
      {
        path: 'list',
        name: 'projectPersonnelManageList',
        component: s420,
        meta: {
          name: '项目人员管理'
        }
      }
    ]
  }
];

const accountManagementAside = [
  {
    path: '/accountManagement/index',
    component: Layout,
    meta: {
      icon: require('./icons/概要1.png'), // 默认
      activeIcon: require('./icons/概要.png'), // 激活
      name: '概要',
      hasAside: true,
      asideName: 'accountManagementAsideList'
    },
    children: [
      {
        path: '/accountManagement/index',
        name: 'accountManagement',
        component: s51,
        meta: {
          name: '子账号管理',
          hasAside: true,
          asideName: 'accountManagementAsideList'
        }
      }
    ]
  },
  {
    path: '/accountManagement',
    component: Layout,
    meta: {
      icon: require('./icons/项目结算管理1.png'), // 默认
      activeIcon: require('./icons/项目结算管理.png'), // 激活
      name: '操作日志',
      hasAside: true,
      asideName: 'accountManagementAsideList'
    },

    children: [
      {
        path: 'operationLog',
        name: 'operationLog',
        component: s52,
        meta: {
          name: '操作日志',
          hasAside: true,
          asideName: 'accountManagementAsideList'
        }
      }
    ]
  },
  {
    path: '/accountManagement',
    component: Layout,
    meta: {
      icon: require('./icons/我的订单1.png'), // 默认
      activeIcon: require('./icons/我的订单.png'), // 激活
      name: '主账号管理',
      hasAside: true,
      asideName: 'accountManagementAsideList'
    },

    children: [
      {
        path: 'mainAccountManagement',
        name: 'mainAccountManagement',
        component: s53,
        meta: {
          name: '主账号管理',
          hasAside: true,
          asideName: 'accountManagementAsideList'
        }
      }
    ]
  }
];

const signAndContractAside = [
  //签约以及合同管理的侧边栏路由
  {
    path: '/contractInformation',
    component: Layout,
    redirect: '/contractInformation/naturalPerson',
    meta: {
      icon: 'http://cdn.yxvzb.com/WEB/sass/img/qianyue.png', // 默认
      activeIcon: 'http://cdn.yxvzb.com/WEB/sass/img/qianyue.png', // 激活
      name: '签约信息',
      hasAside: true,
      asideName: 'signAndContractAsideList'
    },
    children: [
      {
        path: '/contractInformation/naturalPerson',
        name: 'contractInformationNaturalPerson',
        component: () => import('@/page/contractInformation/naturalPerson'),
        meta: {
          name: '自然人',
          hasAside: true,
          asideName: 'signAndContractAsideList'
        }
      },
      {
        path: '/contractInformation/organ',
        name: 'contractInformationOrganization',
        component: () => import('@/page/contractInformation/organization'),
        meta: {
          name: '个体',
          hasAside: true,
          asideName: 'signAndContractAsideList'
        }
      }
    ]
  },
  {
    path: '/contract',
    component: Layout,
    redirect: '/contract/four',
    meta: {
      name: '电子合同',
      asideName: 'signAndContractAsideList',
      icon: 'http://cdn.yxvzb.com/WEB/sass/img/contract.png',
      activeIcon: 'http://cdn.yxvzb.com/WEB/sass/img/contract.png'
    },
    children: [
      {
        path: '/contract/supplier',
        name: 'supplierContract',
        component: () => import('@/page/contract/supplier'), // 供应商合同
        meta: {
          name: '供应商合同',
          hasAside: true,
          asideName: 'signAndContractAsideList',
          parentName: 'contractInformationNaturalPerson' // 提供给menu，定位高亮
        }
      },
      {
        path: '/contract/naturalPerson',
        name: 'naturalPersonContract',
        component: () => import('@/page/contract/person'), // 供应商合同
        meta: {
          name: '自然人合同',
          hasAside: true,
          asideName: 'signAndContractAsideList'
        }
      },
      // FIXME 有其他模块引用
      {
        path: '/contract/platform',
        name: 'signAndContractContractPlatform',
        component: s11,
        meta: {
          name: '平台服务合同',
          hasAside: true,
          asideName: 'signAndContractAsideList'
        }
      },
      {
        path: '/contract/list',
        name: 'contractList',
        component: () => import('@/page/contract/contract-list'),
        meta: {
          name: '电子结算单',
          hasAside: true,
          asideName: 'signAndContractAsideList'
        }
      }
    ]
  },
  {
    path: '/project-settled',
    redirect: '/project-settled/person',
    component: Layout,
    meta: {
      name: '项目入驻',
      icon: 'http://cdn.yxvzb.com/WEB/sass/img/jilu-weidianji.png',
      activeIcon: 'http://cdn.yxvzb.com/WEB/sass/img/jilu.png'
    },
    children: [
      {
        path: 'person',
        name: 'projectSettledPerson',
        component: () => import('@/page/project-settled/person/index.vue'),
        meta: {
          name: '自然人',
          hasAside: true,
          asideName: 'signAndContractAsideList'
        }
      },
      {
        path: 'organ',
        name: 'projectSettledOrgan',
        component: () => import('@/page/project-settled/organ/index.vue'),
        meta: {
          name: '个体',
          hasAside: true,
          asideName: 'signAndContractAsideList'
        }
      }
    ]
  },
  {
    path: '/project-exit',
    redirect: '/project-exit/person',
    component: Layout,
    meta: {
      name: '项目退出',
      icon: 'http://cdn.yxvzb.com/WEB/sass/img/fenpei-weidianji.png',
      activeIcon: 'http://cdn.yxvzb.com/WEB/sass/img/fenpei.png'
    },
    children: [
      {
        path: '/project-exit/person',
        name: 'projectExitNaturalperson', //自然人
        component: () => import('@/page/project-revoke/person/index.vue'),
        meta: {
          name: '自然人',
          hasAside: true,
          asideName: 'signAndContractAsideList'
        }
      },
      {
        path: '/project-exit/organ',
        name: 'projectExitOrgan', //机构，组织，个体单位
        component: () => import('@/page/project-revoke/organ/index.vue'),
        meta: {
          name: '个体',
          hasAside: true,
          asideName: 'signAndContractAsideList'
        }
      }
    ]
  }
  // {
  //   path: '/revoke-settlement',
  //   redirect: '/revoke-settlement/person',
  //   component: Layout,
  //   meta: {
  //     name: '退出结算',
  //     asideName: 'signAndContractAsideList',
  //     icon: 'http://cdn.yxvzb.com/WEB/sass/img/ruzhu.png',
  //     activeIcon: 'http://cdn.yxvzb.com/WEB/sass/img/ruzhu.png'
  //   },
  //   children: [
  //     {
  //       path: '/revoke-settlement/person',
  //       name: 'RevokeSettlementNaturalperson', //自然人
  //       component: s501,
  //       meta: {
  //         name: '自然人',
  //         hasAside: true,
  //         asideName: 'signAndContractAsideList',
  //         props: {
  //           type: 'person'
  //         }
  //       }
  //     },
  //     {
  //       path: '/revoke-settlement/organ',
  //       name: 'RevokeSettlementOrgan', //机构，组织，个体单位
  //       component: s502,
  //       meta: {
  //         name: '个体',
  //         hasAside: true,
  //         asideName: 'signAndContractAsideList',
  //         props: {
  //           type: 'organ'
  //         }
  //       }
  //     }
  //   ]
  // }
];
const projectAside = [
  //项目详情里的侧边栏路由
  {
    path: '/edit',
    component: Layout,
    redirect: '/edit/index',
    meta: {
      icon: require('./icons/aside/项目详情1.svg'), // 默认
      activeIcon: require('./icons/aside/项目详情.svg'), // 激活
      isOne: true,
      hasAside: true,
      name: '编辑项目'
    },
    children: [
      {
        path: 'index',
        name: 'edit',
        component: s15,
        meta: {
          name: '编辑项目', // 菜单名
          hasAside: true,
          asideName: 'projectAsideList'
        }
      },
      {
        // 用于 进入下一个项目
        path: 'index-next',
        name: 'edit-next',
        component: s15,
        meta: {
          name: '编辑项目', // 菜单名
          hasAside: true,
          asideName: 'projectAsideList'
        }
      },
      {
        path: 'questionEdit',
        name: 'questionEdit',
        component: s16,
        meta: {
          name: '编辑问卷',
          hasAside: true,
          asideName: 'projectAsideList'
        }
      },
      {
        path: 'sceneEdit',
        name: 'sceneEdit',
        component: s46,
        meta: {
          name: '编辑场景',
          hasAside: true,
          asideName: 'projectAsideList'
        }
      }
    ]
  },
  {
    path: '/personnel',
    redirect: '/personnel/list',
    component: Layout,
    name: 'personnel', // 当菜单只展示一个时，通过当前的name判断children处于激活状态(list->detail)。如果是多级菜单则不要设置name
    meta: {
      icon: require('./icons/aside/项目人员1.svg'),
      activeIcon: require('./icons/aside/项目人员.svg'),
      isOne: true // 只显示一层aside
    },
    children: [
      {
        path: 'list',
        name: 'personnelList',
        component: s422,
        meta: {
          name: '项目人员',
          hasAside: true,
          asideName: 'projectAsideList'
        }
      }
    ]
  },
  {
    path: '/assign',
    redirect: '/assign/index',
    component: Layout,
    meta: {
      icon: require('./icons/aside/确认任务1.svg'),
      activeIcon: require('./icons/aside/确认任务.svg'),
      hasAside: true,
      isOne: true,
      name: '提交任务'
    },
    children: [
      {
        path: 'index',
        name: 'assign',
        component: () => import('@/page/project-task-submit'),
        // component: s17,
        meta: {
          name: '提交任务',
          hasAside: true,
          asideName: 'projectAsideList'
        }
      }
      // {
      //   path: 'bi',
      //   name: 'bi',
      //   component: s44,
      //   meta: {
      //     name: 'BI报表',
      //     hasAside: true,
      //     asideName: 'projectAsideList'
      //   }
      // }
    ]
  },
  {
    path: '/record',
    redirect: '/record/index',
    component: Layout,
    meta: {
      icon: require('./icons/aside/任务记录1.svg'),
      activeIcon: require('./icons/aside/任务记录.svg'),
      isOne: true,
      hasAside: true,
      name: '任务记录'
    },
    children: [
      {
        path: 'index',
        name: 'record',
        component: s18,
        meta: {
          name: '任务记录',
          hasAside: true,
          asideName: 'projectAsideList'
        }
      },
      {
        path: 'taskCheckLog',
        name: 'taskCheckLog',
        component: s19,
        meta: {
          name: '任务记录',
          hasAside: true,
          asideName: 'projectAsideList',
          parentUrl: '/record/index',
          index: 1
        }
      },
      {
        path: 'taskQuickAuditList',
        name: 'taskQuickAuditList',
        component: s20,
        meta: {
          name: '任务记录',
          hasAside: true,
          asideName: 'projectAsideList',
          parentUrl: '/record/index',
          index: 1
        }
      }
      // {
      //   path: 'detail',
      //   name: 'recordDetail',
      //   component: s19,
      //   meta: {
      //     name: '任务详情',
      //     hasAside: true,
      //     asideName: 'projectAsideList'
      //   }
      // }
    ]
  },
  {
    path: '/signInfo',
    component: Layout,
    redirect: '/v3/project/signInfo',
    meta: {
      icon: 'http://cdn.yxvzb.com/WEB/sass/img/ziranren-weidianji.png',
      activeIcon: 'http://cdn.yxvzb.com/WEB/sass/img/ziranren.png',
      asideName: 'projectAsideList',
      hasAside: true,
      name: '签约信息'
    },
    children: [
      {
        path: '/v3/project/signInfo',
        name: 'signInfo',
        meta: {
          name: '签约信息',
          hasAside: true,
          asideName: 'projectAsideList'
        }
      }
    ]
  },
  {
    path: '/settle',
    component: Layout,
    redirect: '/settle/index',
    meta: {
      icon: require('./icons/aside/项目入驻1.svg'), // 默认
      activeIcon: require('./icons/aside/项目入驻.svg'), // 激活
      isOne: true,
      hasAside: true,
      name: '项目入驻'
    },
    children: [
      {
        path: 'index',
        name: 'settle',
        component: s34,
        meta: {
          name: '项目入驻', // 菜单名
          hasAside: true,
          asideName: 'projectAsideList'
        }
      }
    ]
  },
  {
    path: '/riskManagement',
    component: Layout,
    redirect: '/riskManagement/index',
    name: 'risk',
    meta: {
      icon: require('./icons/aside/项目风控1.svg'),
      activeIcon: require('./icons/aside/项目风控.svg'),
      hasAside: true,
      asideName: 'projectAsideList'
    },
    children: [
      {
        path: 'index',
        name: 'riskCtrl',
        component: s35,
        meta: {
          name: '项目风控',
          hasAside: true,
          asideName: 'projectAsideList'
        }
      }
    ]
  }
  // vue3路由
  // {
  //   path: '/v3/*',
  //   component: Layout,
  //   name: 'v3-project',
  //   redirect: '/v3/information/list',
  //   meta: {
  //     icon: require('./icons/aside/项目风控1.svg'),
  //     activeIcon: require('./icons/aside/项目风控.svg'),
  //     hasAside: true,
  //     asideName: 'projectAsideList'
  //   },
  //   children: [
  //     {
  //       path: '/v3/information/list',
  //       name: 'v3-information-list',
  //       meta: {
  //         name: 'vue3任务进度',
  //         hasAside: true,
  //         asideName: 'projectAsideList',
  //         vue3: true
  //       }
  //     }
  //   ]
  // }
];

const settlementCenter = [
  {
    path: '/account/index',
    component: Layout,
    meta: {
      icon: require('./icons/概要1.png'), // 默认
      activeIcon: require('./icons/概要.png'), // 激活
      name: '结算中心',
      hasAside: true,
      asideName: 'settlementCenterList'
    },

    children: [
      {
        path: '/account/index',
        name: 'settlementCenter',
        component: s1,
        meta: {
          name: '概要',
          hasAside: true,
          asideName: 'settlementCenterList'
        }
      }
    ]
  },
  {
    path: '/projectSettled',
    component: Layout,
    meta: {
      icon: require('./icons/项目结算管理1.png'), // 默认
      activeIcon: require('./icons/项目结算管理.png'), // 激活
      name: '项目结算管理',
      hasAside: true,
      asideName: 'settlementCenterList'
    },

    children: [
      {
        path: 'list',
        name: 'projectSettledList',
        component: projectSettled,
        meta: {
          name: '项目结算管理',
          hasAside: true,
          asideName: 'settlementCenterList'
        }
      }
    ]
  },
  {
    path: '/orderMgmt',
    component: Layout,
    meta: {
      icon: require('./icons/我的订单1.png'), // 默认
      activeIcon: require('./icons/我的订单.png'), // 激活
      name: '我的订单',
      hasAside: true,
      asideName: 'settlementCenterList'
    },

    children: [
      {
        path: 'list',
        name: 'orderMgmt|list',
        component: orderMgmt,
        meta: {
          name: '我的订单',
          hasAside: true,
          asideName: 'settlementCenterList'
        }
      }
    ]
  },
  {
    path: '/bill',
    component: Layout,
    redirect: '/bill/index',
    meta: {
      icon: require('./icons/发票管理1.png'), // 默认
      activeIcon: require('./icons/发票管理.png'), // 激活
      hasAside: true,
      asideName: 'settlementCenterList'
    },
    children: [
      {
        path: '/bill/index',
        name: 'bill',
        component: s3,
        meta: {
          // icon: require('./icons/发票管理1.png'), // 默认
          // activeIcon: require('./icons/发票管理.png'), // 激活
          name: '发票管理',
          hasAside: true,
          asideName: 'settlementCenterList'
        }
      }
    ]
  },
  {
    path: '/v3/terminal-pay',
    component: Layout,
    redirect: '/v3/terminal-pay/index',
    meta: {
      icon: require('./icons/heise.png'), // 默认
      activeIcon: require('./icons/lanse.png'), // 激活
      hasAside: true,
      asideName: 'settlementCenterList',
      hide: true,
      checkShow: async () => {
        const {
          data: { data }
        } = await checkTerminalPayMgr();
        return data;
      }
    },
    children: [
      {
        path: '/v3/terminal-pay/index',
        name: 'terminal-pay',
        meta: {
          name: '终端支付管理',
          hasAside: true,
          asideName: 'settlementCenterList',
          vue3: true
        }
      }
    ]
  }
];
export const zoneAside = [
  {
    path: '/zone',
    name: 'zone',
    redirect: '/zone/list',
    component: Layout,
    meta: {
      headerNavName: '专区列表',
      asideName: 'zoneAsideList',
      isOne: true,
      hasAside: true,
      icon: 'http://cdn.yxvzb.com/WEB/sass/img/zone.png',
      activeIcon: 'http://cdn.yxvzb.com/WEB/sass/img/zoneActive.png'
    },
    children: [
      {
        path: '/zone/list',
        name: 'zoneList',
        component: s48,
        meta: {
          index: 0,
          name: '专区列表',
          selfName: '专区列表',
          asideName: 'zoneAsideList',
          hasAside: true
        }
      },
      {
        path: 'detail',
        name: 'zoneDetail',
        component: s49,
        meta: {
          index: 0,
          name: '专区列表',
          selfName: '专区列表',
          asideName: 'zoneAsideList',
          hasAside: true
        }
      }
    ]
  },
  {
    path: '/information',
    name: 'information',
    redirect: '/information/list',
    component: Layout,
    meta: {
      name: '资源库',
      headerNavName: '资源库',
      asideName: 'zoneAsideList',
      hasAside: true,
      isOne: true,
      icon: 'http://cdn.yxvzb.com/WEB/sass/img/material.png',
      activeIcon: 'http://cdn.yxvzb.com/WEB/sass/img/materialActive.png'
    },
    children: [
      {
        path: 'list',
        name: 'informationList',
        component: s400,
        meta: {
          index: 0,
          name: '资源库',
          selfName: '资源库',
          asideName: 'zoneAsideList',
          hasAside: true
        }
      },
      {
        path: 'detail',
        name: 'informationDetail',
        component: s401,
        meta: {
          index: 0,
          name: '资源库',
          selfName: '资源库',
          asideName: 'zoneAsideList',
          hasAside: true
        }
      }
    ]
  }
];
const freedomRouter = [
  {
    path: '/v3/project/personInvoice',
    name: 'personInvoice',
    component: Layout,
    meta: {
      name: '个体自然人发票',
      hasAside: true,
      asideName: 'settlementCenterList'
    }
  },
  {
    path: '/v3/project/personInvoice/detail',
    name: 'personInvoiceDetail',
    component: Layout,
    meta: {
      name: '个体自然人发票详情',
      hasAside: true,
      asideName: 'settlementCenterList'
    }
  }
];
const dutypaidProof = [
  {
    path: '/dutypaidProof',
    name: 'dutypaidProof',
    redirect: '/dutypaidProof/list',
    component: Layout,
    meta: {
      headerNavName: '完税证明',
      asideName: '完税证明'
    },
    children: [
      {
        path: 'list',
        name: 'dutypaidProofList',
        component: s97,
        meta: {
          index: 0,
          name: '完税证明列表',
          selfName: '完税证明列表'
        }
      }
    ]
  }
];

const submissionMaterial = [
  {
    path: '/v3/bi-tmpl',
    component: Layout,
    name: 'bi-tmpl',
    redirect: '/v3/bi-tmpl/bi-tmpl-list',
    meta: {
      headerNavName: '提交材料管理',
      asideName: 'submissionMaterialAside',
      icon: 'http://cdn.yxvzb.com/WEB/sass/img/jilu-weidianji.png',
      activeIcon: 'http://cdn.yxvzb.com/WEB/sass/img/jilu.png',
      hasAside: true,
      isOne: true
    },
    children: [
      {
        path: '/v3/bi-tmpl/bi-tmpl-list',
        name: 'bi-tmpl-list',
        meta: {
          name: 'BI模板设置',
          hasAside: true,
          selfName: '提交材料管理',
          asideName: 'submissionMaterialAside',
          vue3: true
        }
      },
      {
        path: '/v3/bi-tmpl/bi-tmpl-detail',
        name: 'bi-tmpl-detail',
        meta: {
          name: '新增模板',
          hasAside: true,
          selfName: '提交材料管理',
          asideName: 'submissionMaterialAside',
          vue3: true
        }
      }
    ]
  }
];

const zsManage = [
  {
    path: '/v3/zs-manage',
    component: Layout,
    name: 'zs-manage',
    redirect: '/v3/zs-manage/config',
    children: [
      {
        path: '/v3/zs-manage/oss-list',
        name: 'zs-manage-oss-list',
        meta: { name: '招商管理列表', vue3: true }
      },
      {
        path: '/v3/zs-manage/oss-person',
        name: 'zs-manage-oss-person',
        meta: { name: '招商管理人员列表', vue3: true }
      },
      {
        path: '/v3/zs-manage/config',
        name: 'zs-manage-config',
        meta: { name: '招商配置', vue3: true }
      },
      {
        path: '/v3/zs-manage/drug',
        name: 'zs-manage-drug',
        meta: { name: '药品管理', vue3: true }
      },
      {
        path: '/v3/zs-manage/device',
        name: 'zs-manage-device',
        meta: { name: '器械管理', vue3: true }
      },
      {
        path: '/v3/zs-manage/ability',
        name: 'zs-manage-ability',
        meta: { name: '能力标签', vue3: true }
      },
      {
        path: '/v3/zs-manage/person',
        name: 'zs-manage-person',
        meta: { name: '人员管理', vue3: true }
      }
    ]
  }
];

export default new Router({
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    ...freedomRouter,
    ...parentRoute,
    ...signAndContractAside,
    ...projectAside,
    // ...orderAside,
    ...zoneAside,
    ...settlementCenter,
    ...accountManagementAside,
    ...dutypaidProof,
    ...submissionMaterial,
    ...zsManage
  ]
});
export const parentRouteList = parentRoute;
export const signAndContractAsideList = signAndContractAside;
export const accountManagementAsideList = accountManagementAside;
export const projectAsideList = projectAside;
// export const orderAsideList = orderAside;
export const zoneAsideList = zoneAside;
export const settlementCenterList = settlementCenter;
export const submissionMaterialAside = submissionMaterial;
